/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateUpdateQuoteDto interface.
 */
export function instanceOfCreateUpdateQuoteDto(value) {
    return true;
}
export function CreateUpdateQuoteDtoFromJSON(json) {
    return CreateUpdateQuoteDtoFromJSONTyped(json, false);
}
export function CreateUpdateQuoteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'bidAmount': json['bidAmount'] == null ? undefined : json['bidAmount'],
        'bidCosts': json['bidCosts'] == null ? undefined : json['bidCosts'],
        'bidDays': json['bidDays'] == null ? undefined : json['bidDays'],
        'bidHrcosts': json['bidHrcosts'] == null ? undefined : json['bidHrcosts'],
        'bidOthercosts': json['bidOthercosts'] == null ? undefined : json['bidOthercosts'],
        'rejected': json['rejected'] == null ? undefined : json['rejected'],
        'creationDate': json['creationDate'] == null ? undefined : (new Date(json['creationDate'])),
        'lastmodifiedDate': json['lastmodifiedDate'] == null ? undefined : (new Date(json['lastmodifiedDate'])),
        'externalQuoteId': json['externalQuoteId'] == null ? undefined : json['externalQuoteId'],
        'idContratto': json['idContratto'] == null ? undefined : json['idContratto'],
    };
}
export function CreateUpdateQuoteDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'projectId': value['projectId'],
        'bidAmount': value['bidAmount'],
        'bidCosts': value['bidCosts'],
        'bidDays': value['bidDays'],
        'bidHrcosts': value['bidHrcosts'],
        'bidOthercosts': value['bidOthercosts'],
        'rejected': value['rejected'],
        'creationDate': value['creationDate'] == null ? undefined : ((value['creationDate']).toISOString()),
        'lastmodifiedDate': value['lastmodifiedDate'] == null ? undefined : ((value['lastmodifiedDate']).toISOString()),
        'externalQuoteId': value['externalQuoteId'],
        'idContratto': value['idContratto'],
    };
}
